<app-seg-profile-summary-filters
    [values]="filterValues"
    [compact]="false"
    (filterChange)="onFilterChange($event)"
></app-seg-profile-summary-filters>
